/**
 * Account credential-based integration types
 * These integrations use username/password authentication
 */
export var AccountCredentialIntegrationType;
(function (AccountCredentialIntegrationType) {
    AccountCredentialIntegrationType["BUILDING_LINK"] = "BUILDING_LINK";
    AccountCredentialIntegrationType["PROPERTY_MELD"] = "PROPERTY_MELD";
    AccountCredentialIntegrationType["APPFOLIO"] = "APPFOLIO";
    AccountCredentialIntegrationType["YARDI_VOYAGER"] = "YARDI_VOYAGER";
    AccountCredentialIntegrationType["YARDI_BREEZE"] = "YARDI_BREEZE";
    AccountCredentialIntegrationType["EPIC_PM"] = "EPIC_PM";
    AccountCredentialIntegrationType["ENTRATA"] = "ENTRATA";
    // Add other account-based integrations here
})(AccountCredentialIntegrationType || (AccountCredentialIntegrationType = {}));
//# sourceMappingURL=account-credential-integration-type.js.map